import CommonEmailChange from '../../../common/pages/secure/EmailChange'
import Config from '../../../Config'

class EmailChange extends CommonEmailChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
    this.apiUrl = Config.companyAdminApiUrl.emailChange
  }
}

export default EmailChange



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/EmailChange.js